import { TipoArticolo } from './TipoArticolo';
import { Catalogazione } from './Catalogazione';

export class Articolo {
  _id: string;
  codice: number;
  tipo: TipoArticolo;
  anno: number;
  numero: number;
  idAlfresco: string;
  catalogazione: Catalogazione[] = [];
  indiceGeo: Catalogazione[] = [];
  testata: {
    codice : '05',
    descrizione : 'Testimoni'
  };
  free: boolean = false;
  visibilitaPortale: boolean = false;
  inevidenza: boolean = false;

  titolo: string;
  titoloalternativo: string;
  sottotitolo: string;
  sommario: string;
  autore: string;

  ean13rivista: string;
  datarivista: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Articolo.ts